var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultPageLayout',[_c('ChangePasswordForm',{attrs:{"title":_vm.$t('changePassword.changePassword'),"errorMessage":_vm.errorMessage},on:{"update:errorMessage":function($event){_vm.errorMessage=$event},"update:error-message":function($event){_vm.errorMessage=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }